module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_AUDIO_1.1b928a3f.mpga";